/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BrandLookupResponseDto,
  CreateBrandLookupDto,
  UpdateBrandLookupDto,
} from '../models/index';
import {
    BrandLookupResponseDtoFromJSON,
    BrandLookupResponseDtoToJSON,
    CreateBrandLookupDtoFromJSON,
    CreateBrandLookupDtoToJSON,
    UpdateBrandLookupDtoFromJSON,
    UpdateBrandLookupDtoToJSON,
} from '../models/index';

export interface CreateBrandRequest {
    createBrandLookupDto: CreateBrandLookupDto;
}

export interface GetAllBrandsRequest {
    isActive?: boolean;
}

export interface UpdateBrandRequest {
    id: number;
    updateBrandLookupDto: UpdateBrandLookupDto;
}

/**
 * 
 */
export class BrandLookupServiceApi extends runtime.BaseAPI {

    /**
     */
    async createBrandRaw(requestParameters: CreateBrandRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BrandLookupResponseDto>> {
        if (requestParameters['createBrandLookupDto'] == null) {
            throw new runtime.RequiredError(
                'createBrandLookupDto',
                'Required parameter "createBrandLookupDto" was null or undefined when calling createBrand().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/brand-lookup/brands`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBrandLookupDtoToJSON(requestParameters['createBrandLookupDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BrandLookupResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async createBrand(requestParameters: CreateBrandRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BrandLookupResponseDto> {
        const response = await this.createBrandRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllBrandsRaw(requestParameters: GetAllBrandsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BrandLookupResponseDto>>> {
        const queryParameters: any = {};

        if (requestParameters['isActive'] != null) {
            queryParameters['isActive'] = requestParameters['isActive'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/brand-lookup/brands`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BrandLookupResponseDtoFromJSON));
    }

    /**
     */
    async getAllBrands(requestParameters: GetAllBrandsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BrandLookupResponseDto>> {
        const response = await this.getAllBrandsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateBrandRaw(requestParameters: UpdateBrandRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BrandLookupResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateBrand().'
            );
        }

        if (requestParameters['updateBrandLookupDto'] == null) {
            throw new runtime.RequiredError(
                'updateBrandLookupDto',
                'Required parameter "updateBrandLookupDto" was null or undefined when calling updateBrand().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/brand-lookup/brands/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBrandLookupDtoToJSON(requestParameters['updateBrandLookupDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BrandLookupResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async updateBrand(requestParameters: UpdateBrandRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BrandLookupResponseDto> {
        const response = await this.updateBrandRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
